import React, { useEffect, useState } from "react";
import {
  // useParams,
  useHistory,
} from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import {
  Card,
  Icon,
  Image,
  Header,
  Loader,
  Button,
  Segment,
  Message,
  Popup,
} from "semantic-ui-react";
import logo from "../../../assets/images/logo_sef.png";
import axios from "axios";
import SchoolForm from "./SchoolForm";
import { docTitle } from "../../../helpers/docTitle";

function SchoolData(props) {
  docTitle("Your Schools - SEF");

  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCreated, setCreated] = useState(false);
  const [isDeleted, setDeleted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [uuid, setId] = useState("");
  const [showModal, setShow] = useState(false);
  const [errors, setErrors] = useState({
    response: { show: false, type: "success", message: "" },
  });
  const [updateSchool, setUpdate] = useState({
    shouldUpdate: false,
    school: {},
  });
  // const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/users`,
          {
            headers: { token },
          }
        );
        setLoading(false);
        setUser(response.data.data);
        return;
      } catch (error) {
        console.log(error);
        setLoading(false);
        if (error.message === "Network Error")
          return setErrors({
            ...errors,
            response: { show: true, type: "error", message: error.message },
          });
        if (error.response.status === 500)
          return setErrors({
            ...errors,
            response: {
              show: true,
              type: "error",
              message: error.response.data.error,
            },
          });
        return setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: "Something went wrong, please try again later",
          },
        });
      }
    };

    fetchUser();
    // return () => setUpdate({ shouldUpdate: false, school: {} });
    // eslint-disable-next-line
  }, [isCreated, isDeleted, isUpdated]);

  const handleDeleteSchool = async (schoolId) => {
    setId(schoolId);
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/schools/${schoolId}`,
        { headers: { token: localStorage.getItem("token") } }
      );
      console.log(response.data.data, "res");

      if (response.status === 200) {
        setIsLoading(false);
        setDeleted(true);
        return;
      }
    } catch (error) {
      console.log(error.message, "err");
      setIsLoading(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 403) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 404) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 500) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: "Something went wrong on our end, try again later",
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    return history.push("/auth");
  };

  return (
    <>
      {/* <Row> */}
      <Button
        content="Log out"
        icon="log out"
        iconPosition="right"
        primary
        circular
        floated="right"
        className="m-3"
        onClick={handleLogout}
      />
      {/* </Row> */}
      <Container
        style={{ height: "90vh", backgroundColor: "#f9" }}
        fluid
        className="d-flex w-100 align-items-center"
      >
        <Row>
          <Message
            content={errors.response.message}
            negative={errors.response.type === "error"}
            positive={errors.response.type === "success"}
            hidden={!errors.response.show}
          />
        </Row>
        <SchoolForm
          setCreated={setCreated}
          showModal={showModal}
          setShowModal={setShow}
          updateSchool={updateSchool}
          setUpdate={setUpdate}
          setIsUpdated={setIsUpdated}
        />
        {loading ? (
          <Loader active inline="centered" />
        ) : (
          <>
            {user.schools?.length <= 0 ? (
              <Container>
                <Row>
                  <Col>
                    <Segment placeholder>
                      <Header icon>
                        <Icon name="pdf file outline" />
                        No schools are listed for this user.
                      </Header>
                      <Button
                        primary
                        onClick={() => {
                          setCreated(false);
                          setShow(true);
                        }}
                      >
                        Add School
                      </Button>
                    </Segment>
                  </Col>
                </Row>
              </Container>
            ) : (
              <Row
                className="w-100 d-flex justify-content-center"
                // style={{
                //   backgroundColor: "yellow",
                //   // width: "100%"
                // }}
              >
                <Row className="justify-content-center pb-5">
                  <Col md={4} className="">
                    <Header
                      content="Choose school"
                      as="h1"
                      className="d-flex w-75 flex-row justify-content-center align-items-center"
                    />
                  </Col>
                </Row>
                <Col>
                  <Col
                    md={11}
                    className="d-flex flex-row justify-content-evenly align-items-baseline flex-wrap"
                  >
                    <Card.Group>
                      {user.schools?.map((school) => {
                        return (
                          // <Col className='d-flex flex-row justify-content-center'>

                          <Card
                            raised
                            link
                            color="blue"
                            key={school.uuid}
                            style={{ textDecoration: "none" }}
                          >
                            <Card.Content
                              onClick={() =>
                                history.push(`/dashboard/s/${school.uuid}`)
                              }
                            >
                              <Image
                                src={school.image ? school.image : logo}
                                size="huge"
                                avatar
                                floated="right"
                                className="img-fluid"
                              />
                              <Card.Header>{school.schoolName}</Card.Header>
                              <Card.Meta>
                                <Icon name="map marker alternate" />
                                {school.address}
                              </Card.Meta>
                              <Card.Meta>
                                <Icon name="student" />{" "}
                                {`${school.students.length} students`}
                              </Card.Meta>
                              <Card.Content extra>
                                <strong>{school.schoolName}</strong>{" "}
                                {school.desc}
                              </Card.Content>
                            </Card.Content>

                            <Card.Content extra>
                              <Button
                                size="tiny"
                                icon="edit"
                                circular
                                primary
                                onClick={() => {
                                  setIsUpdated(false);
                                  setShow(true);
                                  setUpdate({ shouldUpdate: true, school });
                                }}
                              />
                              <Button
                                size="tiny"
                                icon="trash"
                                circular
                                negative
                                loading={isLoading && school.uuid === uuid}
                                onClick={() => handleDeleteSchool(school.uuid)}
                              />
                            </Card.Content>
                          </Card>
                          // </Col>
                        );
                      })}
                    </Card.Group>
                  </Col>
                </Col>
                <Col md={1} className="d-flex align-items-center">
                  <Popup
                    content="Add a new school"
                    trigger={
                      <Icon
                        link
                        name="plus"
                        circular
                        size="big"
                        color="dodge blue"
                        onClick={() => {
                          setCreated(false);
                          setShow(true);
                        }}
                      />
                    }
                  />
                </Col>
              </Row>
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default SchoolData;
